import React from "react";

import { BookOpen } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { Card, CardContent } from "@/src/components/ui/card";

import { BULK_HELP_LINKS } from "./bulkHelpLinks";
import BulkPageHeader from "./BulkPageHeader";
import BulkPageLayout from "./BulkPageLayout";
import BulkUploadDropzone from "./BulkUploadDropzone";
import useBulkUpload from "../../hooks/useBulkUpload";
import { BULKS_ROUTE } from "../routes/routes";

import type { JSX } from "react";

import type { AppState } from "../../reducers";

function BulkCreate(): JSX.Element {
  const { t } = useTranslation("editor-bulk");
  const history = useHistory();
  const lang = useSelector((state: AppState) => state.variableReducer.lang);

  const { isUploading, progress, upload } = useBulkUpload({
    onUploaded: (bulkId: string): void => {
      history.replace(`${BULKS_ROUTE}/${bulkId}`);
    },
  });

  return (
    <BulkPageLayout>
      <BulkPageHeader isNew title={t("createBulk")} />

      <Card>
        <CardContent className="flex flex-col gap-5">
          <div className="flex flex-wrap items-center justify-between gap-x-6 gap-y-2">
            <p className="text-muted-foreground text-sm">
              {t("bulk-description")}
            </p>

            <a
              className="text-primary inline-flex shrink-0 items-center gap-1.5 text-sm font-medium hover:underline"
              href={BULK_HELP_LINKS[lang]}
              rel="noopener noreferrer"
              target="_blank"
            >
              <BookOpen aria-hidden="true" className="size-4" />
              {t("editor-help:bulk.label")}
            </a>
          </div>

          <BulkUploadDropzone
            isUploading={isUploading}
            onFileSelected={upload}
            progress={progress}
          />
        </CardContent>
      </Card>
    </BulkPageLayout>
  );
}

export default BulkCreate;
